import { Building03Icon } from '@hugeicons/core-free-icons';
import { createIcon } from '../icon';

export const Building2 = /* @__PURE__ */ createIcon(Building03Icon, 'Building2');
